"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMessage = void 0;
const react_1 = __importStar(require("react"));
const messageCode_1 = require("../../utils/messageCode");
class BaseMessage extends react_1.PureComponent {
    render() {
        const { code, children, fallbackCode, args, className, i18n } = this.props;
        const messages = i18n ? i18n.messages : this.props.messages;
        if (!messages) {
            console.error('localization reducer does not have a message set');
            return react_1.default.createElement("span", null);
        }
        // TODO support fallbackCode in children
        if (children) {
            return react_1.default.createElement("span", { className: className }, messageCode_1.getMessageJsx(messages, code, react_1.default.Children.toArray(children)));
        }
        let message = messageCode_1.getMessage(messages, code, args) || (fallbackCode && messageCode_1.getMessage(messages, fallbackCode, args));
        if (!message) {
            console.info('message code not found. code: %s; fallback: %s', code, fallbackCode);
        }
        message = message || code;
        // Applications that do have html in i18n messages should use this override
        try {
            if (process && process.env && process.env.REACT_APP_ALLOW_MESSAGE_DANGEROUS_SET) {
                /* eslint-disable */
                return react_1.default.createElement("span", { className: className, dangerouslySetInnerHTML: { __html: message } });
                /* eslint-enable */
            }
        }
        catch (e) {
            console.error(e);
        }
        return react_1.default.createElement("span", { className: className }, message);
    }
}
exports.BaseMessage = BaseMessage;
//# sourceMappingURL=BaseMessage.js.map